'use es6';

import { getOfficeHoursStartTime, getNewOfficeHoursStartTime } from './getOfficeHoursStartTime';
import { OFFICE_HOURS } from 'conversations-message-history/office-hours-message/constants/messageTypes';
export const isDuringOfficeHours = message => {
  if (message['@type'] === OFFICE_HOURS) {
    return getNewOfficeHoursStartTime(message) && getNewOfficeHoursStartTime(message) - new Date().getTime() < 0;
  }
  return getOfficeHoursStartTime(message) && getOfficeHoursStartTime(message) - new Date().getTime() < 0;
};